import { render, staticRenderFns } from "./BaseNotice.vue?vue&type=template&id=218fab16&functional=true"
import script from "./BaseNotice.vue?vue&type=script&lang=js"
export * from "./BaseNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports